import { render, staticRenderFns } from "./AssignUsers.vue?vue&type=template&id=32d51040&scoped=true"
import script from "./AssignUsers.vue?vue&type=script&lang=js"
export * from "./AssignUsers.vue?vue&type=script&lang=js"
import style0 from "./AssignUsers.vue?vue&type=style&index=0&id=32d51040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d51040",
  null
  
)

export default component.exports